import { ENV_NAME, RPC_WRITE_ENDPOINTS } from "../../utils/env/env";

export const IS_MAINNET: boolean = ENV_NAME == 'MAINNET'

// RPC ENDPOINTS
export const RPC_WRITE_ENPOINTS = RPC_WRITE_ENDPOINTS.split(',')